import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import ViewSectionName from "./view-section-name";
import ViewDividerSmall from "./view-divider-sm";
import WebbLoader from "./webb-loader";

import { GetAuthUser } from "../services/user-accounts";
import { GetDocsTransactions } from "../services/user-vault";

export default function VaultDocsTransactions(props) {

  const asset = GetAuthUser();
  const { id } = useParams();

  const [loading,setLoading]=useState(true);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setLoading(true);

        setData( (await GetDocsTransactions(JSON.stringify({
          body: { crid: id },
          user: { usid: asset.usid, form: asset.form }
        }))).data)

        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);


  const handleClick = (hash) => {
    window.open("https://rinkeby.etherscan.io/tx/"+hash);
  };

  if (loading)
  return (<> <WebbLoader /> </>)

  if (data.length===0)
  return (<><p className="text-muted small">No Records</p> </>)

  return (
    <>
      <div className="rounded border bg-white">

        {data && data.map((item, i) => (
          <div className="d-flex p-3 border-bottom" key={i}>

            <div className="me-auto">
              <p className="fw-bold text-muted small m-0 p-0">{(item.crts)}</p>
              <p className="small m-0 p-0 line-clamp-sm"><small>{item.hash}</small></p>
            </div>
          
            <div className="text-end" style={{width:'fit-content'}}>
              <button className="btn btn-link p-0"
                onClick={() => handleClick(item.hash)}
              ><small>View</small>
              </button>
            </div>
          </div>
        ))}
        </div>
    </>
  )
}